import React, { useState } from 'react';
import { Grid, Button as MuiButton, TextField } from '@mui/material';
import { JobCode, updateReward } from '../../../../core/API/guestConnect';
import styles from '../SchedulerSetting.module.scss';
import { useFormik } from 'formik';
import * as Yup from 'yup';

interface EditRewardsProps {
	reward: JobCode;
	handleBackClick?: () => void;
	onRewardUpdated?: () => void;
}

const validationSchema = Yup.object({
	title: Yup.string()
		.trim()
		.required('Reward offered is required')
		.min(1, 'Reward offered cannot be empty'),
	description: Yup.string()
		.trim()
		.required('Reward summary is required')
		.min(1, 'Reward summary cannot be empty'),
});

const EditRewards: React.FC<EditRewardsProps> = ({
	reward,
	handleBackClick,
	onRewardUpdated,
}) => {
	const [apiError, setApiError] = useState<string | null>(null);

	const formik = useFormik({
		initialValues: {
			title: (reward as any).title || '',
			description: (reward as any).description || '',
		},
		validationSchema,
		onSubmit: async (values, { setSubmitting }) => {
			setApiError(null);

			try {
				await updateReward(reward.id, {
					...reward,
					title: values.title,
					description: values.description,
				});

				onRewardUpdated?.();
				setTimeout(() => {
					handleBackClick?.();
				}, 500);
			} catch (err: any) {
				setApiError(err?.message || 'Failed to update reward');
				setSubmitting(false);
			}
		},
	});

	return (
		<div className={styles.editJobCode}>
			<Grid container direction="column" spacing={2} pl={2}>
				<Grid container direction="row" justifyContent="space-between">
					<MuiButton className={styles.backButton} onClick={handleBackClick} variant="contained">
						Back
					</MuiButton>
					<MuiButton
						className={styles.submitButton}
						onClick={() => formik.handleSubmit()}
						disabled={formik.isSubmitting}
						variant="contained"
					>
						{formik.isSubmitting ? 'Saving...' : 'Save'}
					</MuiButton>
				</Grid>
				<Grid>
					<h1 className={styles.formTitle}>Edit Guest Connect Reward</h1>
				</Grid>
			</Grid>

			<form className={styles.formContainer} onSubmit={formik.handleSubmit}>
				{apiError && (
					<div style={{ color: '#d32f2f', marginBottom: 16 }}>{apiError}</div>
				)}
				
				<TextField
					label="Reward Offered"
					name="title"
					value={formik.values.title}
					onChange={formik.handleChange}
					onBlur={formik.handleBlur}
					placeholder="Enter title"
					className={styles.input}
					margin="normal"
					fullWidth
					required
					error={formik.touched.title && Boolean(formik.errors.title)}
					helperText={formik.touched.title && formik.errors.title ? String(formik.errors.title) : ''}
				/>

				<TextField
					label="Reward Summary to Display on Campaign"
					name="description"
					type="text"
					value={formik.values.description}
					onChange={formik.handleChange}
					onBlur={formik.handleBlur}
					placeholder="Enter text"
					className={styles.input}
					margin="normal"
					fullWidth
					required
					multiline
					rows={4}
					error={formik.touched.description && Boolean(formik.errors.description)}
					helperText={formik.touched.description && formik.errors.description ? String(formik.errors.description) : ''}
				/>

			</form>
		</div>
	);
};

export default EditRewards;
